// src/components/Products.js
import React from "react";
import { motion } from "framer-motion";

const productItems = [
  { emoji: "🚜", title: "Spraying Robots", desc: "Precise and automated crop spraying" },
  { emoji: "🌿", title: "Weed Control", desc: "Smart weed detection and removal" },
  { emoji: "🧺", title: "Load Carriers", desc: "Carry harvest and supplies easily" },
  { emoji: "📈", title: "Monitoring Systems", desc: "Real-time agri insights & data" },
  { emoji: "🍓", title: "Harvest Assist", desc: "Semi-autonomous picking systems" }
];

const Products = () => (
  <motion.section
    className="section"
    id="products"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    <h2>Our Products</h2>
    <div className="product-grid">
      {productItems.map((item, i) => (
        <motion.div className="product-card" key={i} whileHover={{ scale: 1.05 }}>
          <div className="emoji">{item.emoji}</div>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </motion.div>
      ))}
    </div>
  </motion.section>
);

export default Products;
